import { bl_url_hyperlink_click_event_fact_RowClass } from "../../../../dbschema/bl_url_hyperlink_click_event_fact.model";
import { bl_url_hyperlink_click_event_history_RowClass } from "../../../../dbschema/bl_url_hyperlink_click_event_history.model";
import { bl_url_hyperlink_hdr_RowClass } from "../../../../dbschema/bl_url_hyperlink_hdr.model";
import {BaseContainerModel} from "../../../base-container.model";

export class UrlHyperlinkContainerModel extends BaseContainerModel {
  bl_url_hyperlink_hdr: bl_url_hyperlink_hdr_RowClass = new bl_url_hyperlink_hdr_RowClass();
  bl_url_hyperlink_click_event_fact: bl_url_hyperlink_click_event_fact_RowClass = new bl_url_hyperlink_click_event_fact_RowClass();
  bl_url_hyperlink_click_event_history: bl_url_hyperlink_click_event_history_RowClass = new bl_url_hyperlink_click_event_history_RowClass();
}
